// import React from 'react';
// import { Card, CardContent, Typography, Button, Box, CircularProgress, TextField, InputAdornment, Stack, Divider, IconButton, Pagination } from '@mui/material';
// import SearchIcon from '@mui/icons-material/Search';
// import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import { format, parseISO } from 'date-fns';
// import { useFetch, useFetchInfinite } from '../../../hooks/useFecth';
// import { useSearchTextInput } from '../../../hooks/useSearchTextInput';
// import DatePicker from 'react-multi-date-picker';

// import CalendarIcon from '@mui/icons-material/CalendarToday';
// import CloseIcon from '@mui/icons-material/Close';
// import gregorian_pt from '../../../services/gregorian_pt';

// const PAGE_SIZE = 40;

// export default function ProvidersList({ type = 'telemedicina' }) {
//     const { search, searchProps } = useSearchTextInput();
//     const [createdAt, setCreatedAt] = React.useState('');
//     const [nextDueDate, setNextDueDate] = React.useState('');
//     const [accessionAt, setAccessionAt] = React.useState('');
//     const [canceledAt, setCanceledAt] = React.useState('');
//     const [activatedAt, setActivatedAt] = React.useState('');
//     const [page, setPage] = React.useState(1);
//     console.log('page', page)

//     // Monta os filtros para a query
//     const filters = React.useMemo(() => {
//         let f = { type: type };
//         if (createdAt) f.createdAt = createdAt;
//         if (nextDueDate) f.nextDueDate = nextDueDate;
//         if (search) f.search = search;
//         if (accessionAt) f.accessionAt = accessionAt;
//         if (canceledAt) f.canceledAt = canceledAt;
//         if (activatedAt) f.activatedAt = activatedAt;
//         f.page = page  || 0 ;
//         return f;
//     }, [createdAt, nextDueDate, search, type, accessionAt, canceledAt, activatedAt, page]);

//     // const {
//     //     data : benefits,
//     //     isLoading,
//     //     isFetchingNextPage,
//     //     fetchNextPage,
//     //     hasNextPage,
//     //     refetch,
//     // } = useFetchInfinite('benefits', {
//     //     params: filters,
//     //     pageSize: PAGE_SIZE,
//     // });
//     const { data, mutate, error, isLoading } = useFetch('benefits', {
//         params: filters,
//         // pageSize: PAGE_SIZE,
//     });

//     console.log('benefits ', data);

//     // const handleLoadMore = () => {
//     //     if (hasNextPage && !isFetchingNextPage) {
//     //         fetchNextPage();
//     //     }
//     // };

//     const PickerDateAccession = ({ openCalendar, value, ...props }) => {
//         return (
//             <TextField
//                 placeholder="Selecione um período"
//                 fullWidth
//                 value={value}
//                 label="Data de adesão"
//                 InputProps={{
//                     startAdornment: (
//                         <InputAdornment position="start">
//                             <IconButton onClick={openCalendar}>
//                                 <CalendarIcon />
//                             </IconButton>
//                         </InputAdornment>
//                     ),
//                     endAdornment: (
//                         <InputAdornment position="end" sx={{ display: Boolean(accessionAt) ? 'inherit' : 'none' }}>
//                             <IconButton onClick={() => setAccessionAt('')}>
//                                 <CloseIcon />
//                             </IconButton>
//                         </InputAdornment>
//                     ),
//                 }}
//             />
//         );
//     };

//     const PickerDateCanceled = ({ openCalendar, value, ...props }) => {
//         return (
//             <TextField
//                 placeholder="Selecione um período"
//                 fullWidth
//                 value={value}
//                 label="Data de cancelamento"
//                 InputProps={{
//                     startAdornment: (
//                         <InputAdornment position="start">
//                             <IconButton onClick={openCalendar}>
//                                 <CalendarIcon />
//                             </IconButton>
//                         </InputAdornment>
//                     ),
//                     endAdornment: (
//                         <InputAdornment position="end" sx={{ display: Boolean(canceledAt) ? 'inherit' : 'none' }}>
//                             <IconButton onClick={() => setCanceledAt('')}>
//                                 <CloseIcon />
//                             </IconButton>
//                         </InputAdornment>
//                     ),
//                 }}
//             />
//         );
//     };

//     const PickerDateActivated = ({ openCalendar, value, ...props }) => {
//         return (
//             <TextField
//                 placeholder="Selecione um período"
//                 fullWidth
//                 value={value}
//                 label="Data de ativação"
//                 InputProps={{
//                     startAdornment: (
//                         <InputAdornment position="start">
//                             <IconButton onClick={openCalendar}>
//                                 <CalendarIcon />
//                             </IconButton>
//                         </InputAdornment>
//                     ),
//                     endAdornment: (
//                         <InputAdornment position="end" sx={{ display: Boolean(activatedAt) ? 'inherit' : 'none' }}>
//                             <IconButton onClick={() => setActivatedAt('')}>
//                                 <CloseIcon />
//                             </IconButton>
//                         </InputAdornment>
//                     ),
//                 }}
//             />
//         );
//     };

//     const handleDownload = () => {
//         window.open(`${process.env.REACT_APP_API_URL}/benefits?${new URLSearchParams(filters).toString()}`, '_blank');
//     };

//     return (
//         <Box sx={{ p: 2 }} flexWrap="wrap">
//             <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={2}>
//                 <TextField
//                     {...searchProps}
//                     label="Buscar"
//                     variant="outlined"
//                     size="small"
//                     InputProps={{
//                         startAdornment: (
//                             <InputAdornment position="start">
//                                 <SearchIcon />
//                             </InputAdornment>
//                         ),
//                     }}
//                 />
//                 <DatePicker
//                     containerStyle={{ width: '50%' }}
//                     onChange={e => setAccessionAt(e)}
//                     format="DD/MM/YYYY"
//                     range
//                     dateSeparator=" a "
//                     name="departure_date"
//                     locale={gregorian_pt}
//                     value={accessionAt}
//                     required
//                     render={<PickerDateAccession />}
//                 />

//                 <DatePicker
//                     containerStyle={{ width: '50%' }}
//                     onChange={e => setCanceledAt(e)}
//                     format="DD/MM/YYYY"
//                     range
//                     dateSeparator=" a "
//                     name="departure_date"
//                     locale={gregorian_pt}
//                     value={canceledAt}
//                     required
//                     render={<PickerDateCanceled />}
//                 />
//                 <DatePicker
//                     containerStyle={{ width: '50%' }}
//                     onChange={e => setActivatedAt(e)}
//                     format="DD/MM/YYYY"
//                     range
//                     dateSeparator=" a "
//                     name="departure_date"
//                     locale={gregorian_pt}
//                     value={activatedAt}
//                     required
//                     render={<PickerDateActivated />}
//                 />

//                 <TextField
//                     containerStyle={{ width: '50%' }}
//                     label="Criado em"
//                     type="date"
//                     size="small"
//                     value={createdAt}
//                     onChange={e => setCreatedAt(e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     InputProps={{
//                         startAdornment: (
//                             <InputAdornment position="start">
//                                 <CalendarTodayIcon fontSize="small" />
//                             </InputAdornment>
//                         ),
//                     }}
//                 />
//                 <TextField
//                     label="Próx. vencimento"
//                     type="date"
//                     size="small"
//                     value={nextDueDate}
//                     onChange={e => setNextDueDate(e.target.value)}
//                     InputLabelProps={{ shrink: true }}
//                     InputProps={{
//                         startAdornment: (
//                             <InputAdornment position="start">
//                                 <AccessTimeIcon fontSize="small" />
//                             </InputAdornment>
//                         ),
//                     }}
//                 />
//                 {/* <Button variant="outlined" onClick={refetch}>
//                     Filtrar
//                 </Button> */}
//                 <Button variant="outlined" onClick={handleDownload}>
//                     Baixar planilha
//                 </Button>
//             </Stack>
//             <Divider sx={{ mb: 2 }} />
//             {isLoading === true ? (
//                 <Box display="flex" justifyContent="center" mt={4}>
//                     <CircularProgress />
//                 </Box>
//             ) : (
//                 <>
//                     <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mb={2}>
//                         <Card variant="outlined" sx={{ width: '100%' }}>
//                             <CardContent>
//                                 <Stack direction="row" spacing={2} justifyContent="space-between">
//                                     {/* colunas: plano, status, criado em, próx. vencimento, pessoa */}
//                                     <Typography variant="body2" color="text.secondary">
//                                         Benefício
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Status
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Criado em
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Próx. vencimento
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Ativado
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Cancelado
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Integrado
//                                     </Typography>
//                                     <Typography variant="body2" color="text.secondary">
//                                         Assinante
//                                     </Typography>
//                                 </Stack>
//                             </CardContent>
//                         </Card>
//                     </Stack>

//                     <Stack spacing={2}>
//                         {data?.data?.length === 0 ? (
//                             <Typography variant="body1" color="text.secondary" textAlign="center">
//                                 Nenhum benefício encontrado.
//                             </Typography>
//                         ) : (
//                             data?.data?.map(benefit => (
//                                 <Card key={benefit.id} variant="contained">
//                                     <CardContent>
//                                         <Typography variant="h6" gutterBottom>
//                                             {benefit.planName || 'Sem nome do plano'}
//                                         </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                                             Status: {benefit.status}
//                                         </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                                             Criado em: {benefit.createdAt ? format(parseISO(benefit.createdAt), 'dd/MM/yyyy') : '--'}
//                                         </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                                             Próx. vencimento: {benefit.nextDueDate ? format(parseISO(benefit.nextDueDate), 'dd/MM/yyyy') : '--'}
//                                         </Typography>
//                                         <Typography variant="body2" color="text.secondary">
//                                             Pessoa: {benefit.person?.name || benefit.personId || '--'}
//                                         </Typography>
//                                     </CardContent>
//                                 </Card>
//                             ))
//                         )}
//                     </Stack>
//                 </>
//             )}

//             {data?.totalPages > 0 && (
//                 <Stack p={2} alignItems="center">
//                     <Pagination count={data?.total} page={data?.page} onChange={(e, value) => setPage(value)} color="primary" />
//                 </Stack>
//             )}

//             {/* {data?.hasMore && (
//                 <Box display="flex" justifyContent="center" mt={2}>
//                     <Button onClick={handleLoadMore} disabled={isFetchingNextPage} variant="outlined">
//                         {isFetchingNextPage ? <CircularProgress size={24} /> : 'Carregar mais'}
//                     </Button>
//                 </Box>
//             )} */}
//         </Box>
//     );
// }

import React, { useState } from 'react';
import {
    Card,
    CardContent,
    Typography,
    Button,
    Box,
    CircularProgress,
    TextField,
    InputAdornment,
    Stack,
    Divider,
    IconButton,
    Autocomplete,
    Checkbox,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Menu,
    MenuItem,
    Tooltip,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CalendarIcon from '@mui/icons-material/CalendarToday';
import CloseIcon from '@mui/icons-material/Close';
import { format, parseISO } from 'date-fns';
import DatePicker from 'react-multi-date-picker';
import { useConfirm } from 'material-ui-confirm';


import ListPageLayout from '../../../components/ListPageLayout';
import gregorian_pt from '../../../services/gregorian_pt';
import { useFetch } from '../../../hooks/useFecth';
import { useSearchTextInput } from '../../../hooks/useSearchTextInput';
import server from '../../../services/server';
import SelectClub from '../../../components/SelectClub';
import { Cancel, CheckCircle, MoreVert } from '@mui/icons-material';
import useErrors from '../../../hooks/useErrors';
import Dropdown from '../../../components/Dropdown';

const CUTOFF_DAY_OPTIONS = [
    { value: '10', label: 'Dia 10' },
    { value: '20', label: 'Dia 20' },
    { value: 'last', label: 'Último dia do mês' },
];

function formatCutoffDay(cutoffDay) {
    return CUTOFF_DAY_OPTIONS.find(option => option.value === cutoffDay)?.label || '—';
}

function additionalBenefitName(benefit) {
    return (
        benefit?.aditionalName ||
        benefit?.aditional?.name ||
        benefit?.resaleProduct?.name ||
        '—'
    );
}

function NamedWithId({ id, children, ...props }) {
    const node = <Typography {...props}>{children || '—'}</Typography>;
    if (id == null) return node;
    return (
        <Tooltip title={`ID ${id}`} placement="top" enterDelay={300}>
            {node}
        </Tooltip>
    );
}

function BenefitName({ benefit, sx, ...props }) {
    return (
        <Box sx={{ minWidth: 0, ...sx }}>
            <NamedWithId id={benefit.id} {...props}>
                {additionalBenefitName(benefit)}
            </NamedWithId>
            {benefit?.clickLifeError ? (
                <Tooltip
                    title={benefit.clickLifeError}
                    placement="top-start"
                    enterDelay={200}
                    slotProps={{
                        tooltip: {
                            sx: {
                                maxWidth: 480,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                            },
                        },
                    }}
                >
                    <Typography variant="caption" color="error" noWrap display="block">
                        {benefit.clickLifeError}
                    </Typography>
                </Tooltip>
            ) : null}
        </Box>
    );
}

function hasActivated(value) {
    return Boolean(value || false);
}

function BenefitActionsMenu({ benefit, onActivate, onDesactive }) {
    const canActivate = !hasActivated(benefit?.activatedAt) && !benefit?.canceledAt;
    const canDesactive = !benefit?.canceledAt;

    return (
        <Dropdown>
            <IconButton size="small" aria-label="Ações">
                <MoreVert />
            </IconButton>
            <Menu
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <MenuItem
                    disabled={!canActivate}
                    title={
                        benefit?.type === 'telemedicina'
                            ? 'Confirme que o paciente já foi ativado no painel da Click Life. A integração pode ser manual.'
                            : undefined
                    }
                    onClick={() => onActivate(benefit.id)}
                >
                    <CheckCircle fontSize="small" color={canActivate ? 'success' : 'inherit'} sx={{ mr: 1 }} />
                    Ativar
                </MenuItem>
                <MenuItem
                    disabled={!canDesactive}
                    onClick={() => onDesactive(benefit.id)}
                    sx={{ color: canDesactive ? 'error.main' : undefined }}
                >
                    <Cancel fontSize="small" sx={{ mr: 1 }} />
                    Desativar
                </MenuItem>
            </Menu>
        </Dropdown>
    );
}

function CutoffDayModal({ open, onClose, onConfirm }) {
    const [cutoffDay, setCutoffDay] = useState('10');

    const handleConfirm = () => {
        onConfirm(cutoffDay);
    };

    return (
        <Dialog maxWidth="xs" fullWidth open={open} onClose={onClose} PaperProps={{ sx: { p: 0, m: 0 } }}>
            <DialogTitle>Selecione o dia de corte</DialogTitle>
            <Divider />
            <DialogContent>
                <TextField
                    select
                    label="Dia de corte"
                    fullWidth
                    sx={{ mt: 1 }}
                    value={cutoffDay}
                    onChange={e => setCutoffDay(e.target.value)}
                >
                    {CUTOFF_DAY_OPTIONS.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button variant="contained" onClick={handleConfirm}>
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default function ProvidersList({
    type = 'telemedicina',
    title = 'Benefícios',
    subtitle = 'Lista de benefícios do provedor.',
}) {
    const { search, input, handleChange } = useSearchTextInput();

    const [accessionAt, setAccessionAt] = React.useState('');
    const [canceledAt, setCanceledAt] = React.useState('');
    const [activatedAt, setActivatedAt] = React.useState('');
    const [cutoffDay, setCutoffDay] = React.useState('');
    const [clubId, setClubId] = React.useState(null);
    const [paymentType, setPaymentType] = React.useState(null);
    const [planIds, setPlanIds] = React.useState([]);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [download, setDownload] = React.useState(false);
    const { setErrors, enqueueSnackbar } = useErrors();
    const [selectedBenefitIds, setSelectedBenefitIds] = useState([]);
    const [openCutoffModal, setOpenCutoffModal] = useState(false);

    const paymentTypeOptions = [
        { id: 'BOLETO', label: 'Boleto' },
        { id: 'CREDIT_CARD', label: 'Cartão de crédito' },
        { id: 'PIX', label: 'PIX' },
        { id: 'MONEY', label: 'Dinheiro' },
    ];

    const selectedPaymentType = paymentTypeOptions?.find(item => paymentType === item.id) || null;

    const { data: plansList } = useFetch('plans', {
        params: { paged: false, providers: true, type, ...(clubId && { clubId }) },
    });
    const planOptions = React.useMemo(
        () =>
            (plansList || []).map(({ id, name, price }) => ({
                id,
                label: `${name} - ${Number(price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`,
            })),
        [plansList]
    );
    const selectedPlans = planOptions.filter(p => planIds.includes(p.id));

    // Monta filtros para query (search já vem com debounce do hook)
    const filters = React.useMemo(() => {
        let f = { type };
        if (search) f.search = search;
        if (accessionAt) f.accessionAt = accessionAt;
        if (canceledAt) f.canceledAt = canceledAt;
        if (activatedAt) f.activatedAt = activatedAt;
        if (clubId) f.clubId = clubId;
        if (paymentType) f.paymentType = paymentType;
        if (planIds?.length) f.planIds = planIds;
        if (cutoffDay) f.cutoffDay = cutoffDay;
        f.page = page || 1;
        f.limit = pageSize || 10;
        return f;
    }, [search, type, accessionAt, canceledAt, activatedAt, clubId, paymentType, planIds, page, pageSize, cutoffDay]);

    const { data, isLoading, mutate } = useFetch('benefits', {
        params: filters,
    });

    const handleDownload = async () => {
        try {
            setDownload(true);
            const { data } = await server.get('benefits', {
                params: { ...filters, download: true },
                responseType: 'blob',
            });

            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `benefits-${filters.type}-${new Date().getTime()}.xlsx`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erro ao baixar planilha:', error);
            alert('Erro ao baixar planilha. Tente novamente.');
        } finally {
            setDownload(false);
        }
    };

    // ======== Date Pickers reutilizáveis ==========
    const PickerTemplate = ({ openCalendar, label, value, setValue }) => (
        <TextField
            placeholder="Selecione um período"
            fullWidth
            value={value}
            label={label}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton onClick={openCalendar}>
                            <CalendarIcon />
                        </IconButton>
                    </InputAdornment>
                ),
                endAdornment: (
                    <InputAdornment position="end" sx={{ display: Boolean(value) ? 'inherit' : 'none' }}>
                        <IconButton onClick={() => setValue('')}>
                            <CloseIcon />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );

    //     const PickerDateAccession = ({ openCalendar, value, ...props }) => {
    //         return (
    //             <TextField
    //                 placeholder="Selecione um período"
    //                 fullWidth
    //                 value={value}
    //                 label="Data de adesão"
    //                 InputProps={{
    //                     startAdornment: (
    //                         <InputAdornment position="start">
    //                             <IconButton onClick={openCalendar}>
    //                                 <CalendarIcon />
    //                             </IconButton>
    //                         </InputAdornment>
    //                     ),
    //                     endAdornment: (
    //                         <InputAdornment position="end" sx={{ display: Boolean(accessionAt) ? 'inherit' : 'none' }}>
    //                             <IconButton onClick={() => setAccessionAt('')}>
    //                                 <CloseIcon />
    //                             </IconButton>
    //                         </InputAdornment>
    //                     ),
    //                 }}
    //             />
    //         );
    //     };

    //     const PickerDateCanceled = ({ openCalendar, value, ...props }) => {
    //         return (
    //             <TextField
    //                 placeholder="Selecione um período"
    //                 fullWidth
    //                 value={value}
    //                 label="Data de cancelamento"
    //                 InputProps={{
    //                     startAdornment: (
    //                         <InputAdornment position="start">
    //                             <IconButton onClick={openCalendar}>
    //                                 <CalendarIcon />
    //                             </IconButton>
    //                         </InputAdornment>
    //                     ),
    //                     endAdornment: (
    //                         <InputAdornment position="end" sx={{ display: Boolean(canceledAt) ? 'inherit' : 'none' }}>
    //                             <IconButton onClick={() => setCanceledAt('')}>
    //                                 <CloseIcon />
    //                             </IconButton>
    //                         </InputAdornment>
    //                     ),
    //                 }}
    //             />
    //         );
    //     };

    //     const PickerDateActivated = ({ openCalendar, value, ...props }) => {
    //         return (
    //             <TextField
    //                 placeholder="Selecione um período"
    //                 fullWidth
    //                 value={value}
    //                 label="Data de ativação"
    //                 InputProps={{
    //                     startAdornment: (
    //                         <InputAdornment position="start">
    //                             <IconButton onClick={openCalendar}>
    //                                 <CalendarIcon />
    //                             </IconButton>
    //                         </InputAdornment>
    //                     ),
    //                     endAdornment: (
    //                         <InputAdornment position="end" sx={{ display: Boolean(activatedAt) ? 'inherit' : 'none' }}>
    //                             <IconButton onClick={() => setActivatedAt('')}>
    //                                 <CloseIcon />
    //                             </IconButton>
    //                         </InputAdornment>
    //                     ),
    //                 }}
    //             />
    //         );
    //     };
    // ==================================================

    const confirm = useConfirm();
    const handleActivate = async id => {
        try {
            await confirm({
                title: 'Ativar benefício',
                description: 'Tem certeza que deseja ativar este benefício?',
                confirmationText: 'Confirmar',
            });
            await server.put(`benefits/${id}/activate`);
            await mutate();
            enqueueSnackbar('Benefício ativado com sucesso');
        } catch (error) {
            setErrors(error);
        }
    };

    const handleDesactive = async id => {
        try {
            await confirm({
                title: 'Desativar benefício',
                description: 'Tem certeza que deseja desativar este benefício?',
                confirmationText: 'Confirmar',
            });
            await server.put(`benefits/${id}/desactivate`);
            await mutate();
            enqueueSnackbar('Benefício desativado com sucesso');
        } catch (error) {
            setErrors(error);
        }
    };

    const handleToggleBenefitSelection = benefitId => {
        setSelectedBenefitIds(prev =>
            prev.includes(benefitId) ? prev.filter(id => id !== benefitId) : [...prev, benefitId],
        );
    };

    const handleSelectPageBenefits = () => {
        const pageIds = (data?.data ?? []).map(item => item.id).filter(Boolean);
        setSelectedBenefitIds(prev => {
            const allSelected = pageIds.length > 0 && pageIds.every(id => prev.includes(id));
            if (allSelected) {
                return prev.filter(id => !pageIds.includes(id));
            }
            return [...new Set([...prev, ...pageIds])];
        });
    };

    const handleBulkActivate = async () => {
        if (!selectedBenefitIds.length) return;
        try {
            await confirm({
                title: 'Ativar benefícios em massa',
                description: `Ativar até ${selectedBenefitIds.length} benefício(s) selecionado(s)? Itens já ativados ou cancelados serão ignorados.`,
                confirmationText: 'Ativar selecionados',
            });
            const { data: body } = await server.put('benefits/bulk/activate', {
                benefitIds: selectedBenefitIds,
            });
            const updated = body?.data?.updated ?? 0;
            const skipped = body?.data?.skipped ?? 0;
            enqueueSnackbar(
                skipped > 0
                    ? `${updated} ativado(s), ${skipped} ignorado(s).`
                    : `${updated} benefício(s) ativado(s).`,
            );
            setSelectedBenefitIds([]);
            await mutate();
        } catch (error) {
            if (error !== undefined) setErrors(error);
        }
    };

    const handleBulkDesactive = async () => {
        if (!selectedBenefitIds.length) return;
        try {
            await confirm({
                title: 'Inativar benefícios em massa',
                description: `Inativar até ${selectedBenefitIds.length} benefício(s) selecionado(s)? Itens já cancelados serão ignorados.`,
                confirmationText: 'Inativar selecionados',
                confirmationButtonProps: { color: 'error' },
            });
            const { data: body } = await server.put('benefits/bulk/desactivate', {
                benefitIds: selectedBenefitIds,
            });
            const updated = body?.data?.updated ?? 0;
            const skipped = body?.data?.skipped ?? 0;
            enqueueSnackbar(
                skipped > 0
                    ? `${updated} inativado(s), ${skipped} ignorado(s).`
                    : `${updated} benefício(s) inativado(s).`,
            );
            setSelectedBenefitIds([]);
            await mutate();
        } catch (error) {
            if (error !== undefined) setErrors(error);
        }
    };

    const handleChangeCutoffDate = () => {
        if (!selectedBenefitIds.length) return;
        setOpenCutoffModal(true);
    };

    const handleConfirmCutoffDay = async selectedCutoffDay => {
        try {
            await server.put('benefits/cutoff-date', {
                benefitIds: selectedBenefitIds,
                cutoffDay: selectedCutoffDay,
            });
            enqueueSnackbar('Dia de corte atualizado com sucesso');
            setOpenCutoffModal(false);
            setSelectedBenefitIds([]);
            await mutate();
        } catch (error) {
            setErrors(error);
        }
    };

    const hasFilters = Boolean(
        search ||
            accessionAt ||
            canceledAt ||
            activatedAt ||
            cutoffDay ||
            clubId ||
            paymentType ||
            planIds?.length,
    );

    const handleClearFilters = () => {
        handleChange('');
        setAccessionAt('');
        setCanceledAt('');
        setActivatedAt('');
        setCutoffDay('');
        setClubId(null);
        setPaymentType(null);
        setPlanIds([]);
        setPage(1);
    };

    const rows = data?.data ?? [];
    const totalCount = data?.total ?? rows.length;
    const pageIds = rows.map(item => item.id).filter(Boolean);
    const allPageSelected = pageIds.length > 0 && pageIds.every(id => selectedBenefitIds.includes(id));
    const somePageSelected = pageIds.some(id => selectedBenefitIds.includes(id));

    return (
        <>
            <ListPageLayout
                title={title}
                subtitle={subtitle}
                counts={[{ label: 'benefícios', value: totalCount, color: 'primary' }]}
                loading={isLoading && !data}
                filterActive={hasFilters}
                onClearFilters={hasFilters ? handleClearFilters : null}
                viewStorageKey={`admin-providers-${type}-view`}
                actions={
                    <>
                        <Button size="small" variant="outlined" onClick={handleDownload} disabled={download}>
                            {download ? 'Baixando…' : 'Baixar planilha'}
                        </Button>
                        {selectedBenefitIds.length > 0 && (
                            <>
                                <Button size="small" variant="outlined" color="success" onClick={handleBulkActivate}>
                                    Ativar ({selectedBenefitIds.length})
                                </Button>
                                <Button size="small" variant="outlined" color="error" onClick={handleBulkDesactive}>
                                    Inativar ({selectedBenefitIds.length})
                                </Button>
                                <Button size="small" variant="outlined" onClick={handleChangeCutoffDate}>
                                    Alterar dia de corte ({selectedBenefitIds.length})
                                </Button>
                            </>
                        )}
                    </>
                }
                isEmpty={!isLoading && rows.length === 0}
                empty={
                    <Typography variant="body1" color="text.secondary" textAlign="center">
                        Nenhum benefício encontrado.
                    </Typography>
                }
                pagination={{
                    page: (data?.page ?? 0) + 1 || page,
                    pages: data?.totalPages || 1,
                    total: totalCount,
                    pageSize,
                    onChange: (_, newPage) => setPage(newPage),
                    onPageSizeChange: nextSize => {
                        setPageSize(nextSize);
                        setPage(1);
                    },
                    itemLabel: totalCount === 1 ? 'benefício' : 'benefícios',
                }}
                filterPanel={({ close }) => (
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            size="small"
                            label="Buscar"
                            value={input}
                            onChange={e => handleChange(e.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon fontSize="small" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                        <SelectClub
                            fullWidth
                            size="small"
                            value={clubId}
                            name="clubId"
                            onChange={e => setClubId(e.target.value || null)}
                        />
                        <Autocomplete
                            fullWidth
                            size="small"
                            options={paymentTypeOptions || []}
                            value={selectedPaymentType || null}
                            onChange={(e, newValue) => setPaymentType(newValue?.id || null)}
                            renderInput={params => <TextField {...params} label="Tipo de pagamento" />}
                        />
                        <Autocomplete
                            multiple
                            fullWidth
                            size="small"
                            options={planOptions}
                            value={selectedPlans}
                            onChange={(e, newValue) => setPlanIds(newValue.map(p => p.id))}
                            getOptionLabel={opt => opt?.label ?? ''}
                            isOptionEqualToValue={(opt, val) => opt.id === val.id}
                            renderInput={params => <TextField {...params} label="Planos" />}
                        />
                        <DatePicker
                            containerStyle={{ width: '100%' }}
                            onChange={e => setAccessionAt(e)}
                            format="DD/MM/YYYY"
                            range
                            dateSeparator=" a "
                            locale={gregorian_pt}
                            value={accessionAt}
                            render={
                                <PickerTemplate label="Data de adesão" value={accessionAt} setValue={setAccessionAt} />
                            }
                        />
                        <DatePicker
                            containerStyle={{ width: '100%' }}
                            onChange={e => setCanceledAt(e)}
                            format="DD/MM/YYYY"
                            range
                            dateSeparator=" a "
                            locale={gregorian_pt}
                            value={canceledAt}
                            render={
                                <PickerTemplate
                                    label="Data de cancelamento"
                                    value={canceledAt}
                                    setValue={setCanceledAt}
                                />
                            }
                        />
                        <DatePicker
                            containerStyle={{ width: '100%' }}
                            onChange={e => setActivatedAt(e)}
                            format="DD/MM/YYYY"
                            range
                            dateSeparator=" a "
                            locale={gregorian_pt}
                            value={activatedAt}
                            render={
                                <PickerTemplate
                                    label="Data de ativação"
                                    value={activatedAt}
                                    setValue={setActivatedAt}
                                />
                            }
                        />
                        <TextField
                            select
                            label="Dia de corte"
                            fullWidth
                            value={cutoffDay}
                            onChange={e => setCutoffDay(e.target.value)}
                        >
                            <MenuItem value="">Todos</MenuItem>
                            {CUTOFF_DAY_OPTIONS.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Button variant="contained" fullWidth onClick={() => close?.()}>
                            Fechar filtros
                        </Button>
                    </Stack>
                )}
            >
                {({ viewMode }) =>
                    isLoading ? (
                        <Box display="flex" justifyContent="center" py={6}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box sx={{ p: 2 }}>
                            {viewMode === 'list' && (
                                <Card variant="outlined" sx={{ mb: 1.5, display: { xs: 'none', md: 'block' } }}>
                                    <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
                                        <Stack direction="row" spacing={2} alignItems="center">
                                            <Box sx={{ width: 40, flex: '0 0 40px' }}>
                                                <Checkbox
                                                    size="small"
                                                    checked={allPageSelected}
                                                    indeterminate={somePageSelected && !allPageSelected}
                                                    onChange={handleSelectPageBenefits}
                                                    inputProps={{ 'aria-label': 'Selecionar benefícios da página' }}
                                                />
                                            </Box>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 1 }}>
                                                Benefício
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 0.8 }}>
                                                Status
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 0.7 }}>
                                                Criado
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 0.7 }}>
                                                Click Life
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 0.7 }}>
                                                Ativo
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 0.7 }}>
                                                Cancelado
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 1.2 }}>
                                                Clube
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 1.2 }}>
                                                Assinante
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 0.7 }}>
                                                Corte
                                            </Typography>
                                            <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ flex: 0.4 }}>
                                                Ações
                                            </Typography>
                                        </Stack>
                                    </CardContent>
                                </Card>
                            )}

                            <Box
                                sx={{
                                    display: viewMode === 'cards' ? 'grid' : 'flex',
                                    flexDirection: 'column',
                                    gap: 1,
                                    gridTemplateColumns:
                                        viewMode === 'cards'
                                            ? { xs: '1fr', sm: '1fr 1fr', lg: '1fr 1fr 1fr' }
                                            : undefined,
                                }}
                            >
                                {rows.map(benefit => {
                                    if (viewMode === 'cards') {
                                        return (
                                            <Card
                                                key={benefit.id}
                                                variant="outlined"
                                                sx={{
                                                    p: 2,
                                                    borderColor: benefit.processedAt ? 'success.main' : undefined,
                                                    borderWidth: benefit.processedAt ? 2 : 1,
                                                }}
                                            >
                                                <Stack spacing={1}>
                                                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                                                        <Checkbox
                                                            disabled={benefit.processedAt}
                                                            checked={selectedBenefitIds.includes(benefit.id)}
                                                            onChange={() => handleToggleBenefitSelection(benefit.id)}
                                                            size="small"
                                                        />
                                                        <BenefitActionsMenu
                                                            benefit={benefit}
                                                            onActivate={handleActivate}
                                                            onDesactive={handleDesactive}
                                                        />
                                                    </Stack>
                                                    <BenefitName benefit={benefit} fontWeight={700} />
                                                    <Typography variant="body2" color="text.secondary">
                                                        {benefit.status}
                                                    </Typography>
                                                    <NamedWithId id={benefit?.Club?.id || benefit?.clubId} variant="body2">
                                                        {benefit?.Club?.name}
                                                    </NamedWithId>
                                                    <NamedWithId id={benefit.person?.id || benefit.personId} variant="body2">
                                                        {benefit.person?.name || benefit.personId}
                                                    </NamedWithId>
                                                    <Typography variant="body2" color="text.secondary">
                                                        Corte: {formatCutoffDay(benefit.cutoffDay)}
                                                    </Typography>
                                                </Stack>
                                            </Card>
                                        );
                                    }

                                    return (
                                        <Card
                                            key={benefit.id}
                                            variant="outlined"
                                            sx={{
                                                borderColor: benefit.processedAt ? 'success.main' : undefined,
                                                borderWidth: benefit.processedAt ? 2 : 1,
                                            }}
                                        >
                                            <CardContent sx={{ py: 1.2, '&:last-child': { pb: 1.2 } }}>
                                                <Stack direction="row" spacing={2} alignItems="center">
                                                    <Box sx={{ width: 40, flex: '0 0 40px' }}>
                                                        <Checkbox
                                                            disabled={benefit.processedAt}
                                                            checked={selectedBenefitIds.includes(benefit.id)}
                                                            onChange={() => handleToggleBenefitSelection(benefit.id)}
                                                        />
                                                    </Box>
                                                    <BenefitName
                                                        benefit={benefit}
                                                        variant="body2"
                                                        sx={{ flex: 1, minWidth: 0 }}
                                                        noWrap
                                                    />
                                                    <Typography variant="body2" sx={{ flex: 0.8, minWidth: 0 }} noWrap>
                                                        {benefit.status}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 0.7, minWidth: 0 }} noWrap>
                                                        {benefit.createdAt ? format(parseISO(benefit.createdAt), 'dd/MM/yyyy') : '—'}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 0.7, minWidth: 0 }} noWrap>
                                                        {benefit.integratedAt
                                                            ? format(parseISO(benefit.integratedAt), 'dd/MM/yyyy')
                                                            : '—'}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 0.7, minWidth: 0 }} noWrap>
                                                        {benefit.activatedAt
                                                            ? format(parseISO(benefit.activatedAt), 'dd/MM/yyyy')
                                                            : '—'}
                                                    </Typography>
                                                    <Typography variant="body2" sx={{ flex: 0.7, minWidth: 0 }} noWrap>
                                                        {benefit.canceledAt
                                                            ? format(parseISO(benefit.canceledAt), 'dd/MM/yyyy')
                                                            : '—'}
                                                    </Typography>
                                                    <NamedWithId
                                                        id={benefit?.Club?.id || benefit?.clubId}
                                                        variant="body2"
                                                        sx={{ flex: 1.2, minWidth: 0 }}
                                                        noWrap
                                                    >
                                                        {benefit?.Club?.name}
                                                    </NamedWithId>
                                                    <NamedWithId
                                                        id={benefit.person?.id || benefit.personId}
                                                        variant="body2"
                                                        sx={{ flex: 1.2, minWidth: 0 }}
                                                        noWrap
                                                    >
                                                        {benefit.person?.name || benefit.personId}
                                                    </NamedWithId>
                                                    <Typography variant="body2" sx={{ flex: 0.7, minWidth: 0 }} noWrap>
                                                        {formatCutoffDay(benefit.cutoffDay)}
                                                    </Typography>
                                                    <Box sx={{ flex: 0.4, minWidth: 0 }}>
                                                        <BenefitActionsMenu
                                                            benefit={benefit}
                                                            onActivate={handleActivate}
                                                            onDesactive={handleDesactive}
                                                        />
                                                    </Box>
                                                </Stack>
                                            </CardContent>
                                        </Card>
                                    );
                                })}
                            </Box>
                        </Box>
                    )
                }
            </ListPageLayout>

            <CutoffDayModal
                open={openCutoffModal}
                onClose={() => setOpenCutoffModal(false)}
                onConfirm={handleConfirmCutoffDay}
            />
        </>
    );
}
